import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .DIImgContainer': {
    width: '100%',
    height: theme.spacing(62.5),
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
  },
  '& .DIItemRow': {
    paddingBottom: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    borderBottom: ` 1px solid ${theme.palette.divider[4]}`,
    '&:last-child': {
      marginBottom: theme.spacing(4),
      borderBottom: '0px',
      paddingBottom: 0,
    },
  },

  '& .DIIcon': {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    verticalAlign: 'top',
  },
  '& .DISAvailbelityNote': {
    padding: theme.spacing(0.5, 2),
    borderLeft: ` 3px solid ${theme.palette.divider[7]}`,
    fontStyle: 'italic',
  },
  '& .DIDescSpacing': {
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
  '& a': {
    color: theme.palette.common.white,
    textDecoration: 'underline',
  },
}));

export default StyledBox;
